function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Theme } from "../core/Theme";
import { MultiDisposer } from "../core/util/Disposer";
import { p100, percent } from "../core/util/Percent";
import * as $array from "../core/util/Array";
/**
 * A configurable theme that dynamically adapts chart settings for best fit
 * in available space.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/responsive/} for more info
 */
export var ResponsiveTheme = /*#__PURE__*/function (_Theme) {
  _inherits(ResponsiveTheme, _Theme);
  var _super = _createSuper(ResponsiveTheme);
  function ResponsiveTheme() {
    var _this;
    _classCallCheck(this, ResponsiveTheme);
    _this = _super.apply(this, arguments);
    /**
     * Currently added rules.
     */
    Object.defineProperty(_assertThisInitialized(_this), "responsiveRules", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    return _this;
  }
  // Breakpoint functions (for use in `relevant` clause of the responsive rules)
  _createClass(ResponsiveTheme, [{
    key: "addRule",
    value:
    /**
     * Adds a responsive rule as well as retuns it.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/responsive/} for more info
     * @param   rule  Responsive rule
     * @return        Responsive rule
     */
    function addRule(rule) {
      var _this2 = this;
      if (rule.name && !rule.template) {
        rule.template = this.rule(rule.name, rule.tags);
      }
      rule._dp = new MultiDisposer([this._root._rootContainer.onPrivate("width", function (_width) {
        if (_this2._isUsed()) {
          _this2._applyRule(rule);
        }
      }), this._root._rootContainer.onPrivate("height", function (_height) {
        if (_this2._isUsed()) {
          _this2._applyRule(rule);
        }
      })]);
      this.responsiveRules.push(rule);
      this._applyRule(rule);
      return rule;
    }
    /**
     * Removes the responsive rule.
     *
     * @param  rule  Responsive rule
     */
  }, {
    key: "removeRule",
    value: function removeRule(rule) {
      $array.remove(this.responsiveRules, rule);
      if (rule._dp) {
        rule._dp.dispose();
      }
    }
  }, {
    key: "_isUsed",
    value: function _isUsed() {
      return this._root._rootContainer.get("themes").indexOf(this) !== -1;
    }
  }, {
    key: "_applyRule",
    value: function _applyRule(rule) {
      var w = this._root._rootContainer.getPrivate("width");
      var h = this._root._rootContainer.getPrivate("height");
      var relevant = rule.relevant.call(rule, w, h);
      var applied = rule.applied;
      if (relevant) {
        if (!applied) {
          rule.applied = true;
          if (rule.template && rule.settings) {
            rule.template.setAll(rule.settings);
          }
          if (rule.applying) {
            rule.applying.call(rule);
          }
        }
      } else if (applied) {
        rule.applied = false;
        if (rule.template) {
          rule.template.removeAll();
        }
        if (rule.removing) {
          rule.removing.call(rule);
        }
      }
    }
    /**
     * Adds default rules for various chart types and most standard scenarios.
     */
  }, {
    key: "setupDefaultRules",
    value: function setupDefaultRules() {
      var _this3 = this;
      _get(_getPrototypeOf(ResponsiveTheme.prototype), "setupDefaultRules", this).call(this);
      var addRule = function addRule(rule) {
        return _this3.addRule(rule);
      };
      /**
       * ========================================================================
       * Universal
       * ========================================================================
       */
      addRule({
        name: "Chart",
        relevant: ResponsiveTheme.widthXXS,
        settings: {
          paddingLeft: 0,
          paddingRight: 0
        }
      });
      addRule({
        name: "Chart",
        relevant: ResponsiveTheme.heightXXS,
        settings: {
          paddingTop: 0,
          paddingBottom: 0
        }
      });
      addRule({
        name: "Bullet",
        relevant: ResponsiveTheme.isXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Legend",
        relevant: ResponsiveTheme.isXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "HeatLegend",
        tags: ["vertical"],
        relevant: ResponsiveTheme.widthXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "HeatLegend",
        tags: ["horizontal"],
        relevant: ResponsiveTheme.heightXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Label",
        tags: ["heatlegend", "start"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Label",
        tags: ["heatlegend", "end"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Button",
        tags: ["resize"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      /**
       * ========================================================================
       * XY
       * ========================================================================
       */
      addRule({
        name: "AxisRendererX",
        relevant: ResponsiveTheme.heightXS,
        settings: {
          inside: true
        }
      });
      addRule({
        name: "AxisRendererY",
        relevant: ResponsiveTheme.widthXS,
        settings: {
          inside: true
        }
      });
      addRule({
        name: "AxisRendererXLabel",
        relevant: ResponsiveTheme.heightXS,
        settings: {
          minPosition: 0.1,
          maxPosition: 0.9
        }
      });
      addRule({
        name: "AxisLabel",
        tags: ["y"],
        relevant: ResponsiveTheme.widthXS,
        settings: {
          centerY: p100,
          maxPosition: 0.9
        }
      });
      addRule({
        name: "AxisLabel",
        tags: ["x"],
        relevant: ResponsiveTheme.heightXXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "AxisLabel",
        tags: ["y"],
        relevant: ResponsiveTheme.widthXXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "AxisTick",
        tags: ["x"],
        relevant: ResponsiveTheme.heightXS,
        settings: {
          inside: true,
          minPosition: 0.1,
          maxPosition: 0.9
        }
      });
      addRule({
        name: "AxisTick",
        tags: ["y"],
        relevant: ResponsiveTheme.widthXXS,
        settings: {
          inside: true,
          minPosition: 0.1,
          maxPosition: 0.9
        }
      });
      addRule({
        name: "Grid",
        relevant: ResponsiveTheme.maybeXXS,
        settings: {
          forceHidden: true
        }
      });
      /**
       * ========================================================================
       * Radar
       * ========================================================================
       */
      addRule({
        name: "RadialLabel",
        tags: ["radial"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "RadialLabel",
        tags: ["circular"],
        relevant: ResponsiveTheme.maybeS,
        settings: {
          inside: true
        }
      });
      addRule({
        name: "AxisTick",
        relevant: ResponsiveTheme.maybeS,
        settings: {
          inside: true
        }
      });
      addRule({
        name: "RadialLabel",
        tags: ["circular"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "AxisTick",
        tags: ["circular"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          inside: true
        }
      });
      /**
       * ========================================================================
       * Pie
       * ========================================================================
       */
      addRule({
        name: "PieChart",
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          radius: percent(99)
        }
      });
      addRule({
        name: "PieChart",
        relevant: ResponsiveTheme.widthM,
        settings: {
          radius: percent(99)
        }
      });
      addRule({
        name: "RadialLabel",
        tags: ["pie"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "RadialLabel",
        tags: ["pie"],
        relevant: ResponsiveTheme.widthM,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["pie"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["pie"],
        relevant: ResponsiveTheme.widthM,
        settings: {
          forceHidden: true
        }
      });
      /**
       * ========================================================================
       * Funnel
       * ========================================================================
       */
      addRule({
        name: "FunnelSeries",
        relevant: ResponsiveTheme.widthM,
        settings: {
          alignLabels: false
        }
      });
      addRule({
        name: "Label",
        tags: ["funnel", "vertical"],
        relevant: ResponsiveTheme.widthL,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["funnel", "vertical"],
        relevant: ResponsiveTheme.widthL,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Label",
        tags: ["funnel", "horizontal"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["funnel", "horizontal"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      /**
       * ========================================================================
       * Pyramid
       * ========================================================================
       */
      addRule({
        name: "PyramidSeries",
        relevant: ResponsiveTheme.widthM,
        settings: {
          alignLabels: false
        }
      });
      addRule({
        name: "Label",
        tags: ["pyramid", "vertical"],
        relevant: ResponsiveTheme.widthL,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["pyramid", "vertical"],
        relevant: ResponsiveTheme.widthL,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Label",
        tags: ["pyramid", "horizontal"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["pyramid", "horizontal"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      /**
       * ========================================================================
       * Pictorial
       * ========================================================================
       */
      addRule({
        name: "PictorialStackedSeries",
        relevant: ResponsiveTheme.widthM,
        settings: {
          alignLabels: false
        }
      });
      addRule({
        name: "Label",
        tags: ["pictorial", "vertical"],
        relevant: ResponsiveTheme.widthL,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["pictorial", "vertical"],
        relevant: ResponsiveTheme.widthL,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Label",
        tags: ["pictorial", "horizontal"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Tick",
        tags: ["pictorial", "horizontal"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      /**
       * ========================================================================
       * Map
       * ========================================================================
       */
      // Nothing to do here
      /**
       * ========================================================================
       * Flow (Sankey+Chord)
       * ========================================================================
       */
      addRule({
        name: "Label",
        tags: ["flow", "horizontal"],
        relevant: ResponsiveTheme.widthS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Label",
        tags: ["flow", "vertical"],
        relevant: ResponsiveTheme.heightS,
        settings: {
          forceHidden: true
        }
      });
      addRule({
        name: "Chord",
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          radius: percent(99)
        }
      });
      /**
       * ========================================================================
       * Hierarchy (Treemap, Partition, Sunburst, Pack, ForceDirected)
       * ========================================================================
       */
      addRule({
        name: "Label",
        tags: ["hierarchy", "node"],
        relevant: ResponsiveTheme.maybeXS,
        settings: {
          forceHidden: true
        }
      });
    }
  }], [{
    key: "widthXXS",
    value: function widthXXS(width, _height) {
      return width <= ResponsiveTheme.XXS;
    }
  }, {
    key: "widthXS",
    value: function widthXS(width, _height) {
      return width <= ResponsiveTheme.XS;
    }
  }, {
    key: "widthS",
    value: function widthS(width, _height) {
      return width <= ResponsiveTheme.S;
    }
  }, {
    key: "widthM",
    value: function widthM(width, _height) {
      return width <= ResponsiveTheme.M;
    }
  }, {
    key: "widthL",
    value: function widthL(width, _height) {
      return width <= ResponsiveTheme.L;
    }
  }, {
    key: "widthXL",
    value: function widthXL(width, _height) {
      return width <= ResponsiveTheme.XL;
    }
  }, {
    key: "widthXXL",
    value: function widthXXL(width, _height) {
      return width <= ResponsiveTheme.XXL;
    }
  }, {
    key: "heightXXS",
    value: function heightXXS(_width, height) {
      return height <= ResponsiveTheme.XXS;
    }
  }, {
    key: "heightXS",
    value: function heightXS(_width, height) {
      return height <= ResponsiveTheme.XS;
    }
  }, {
    key: "heightS",
    value: function heightS(_width, height) {
      return height <= ResponsiveTheme.S;
    }
  }, {
    key: "heightM",
    value: function heightM(_width, height) {
      return height <= ResponsiveTheme.M;
    }
  }, {
    key: "heightL",
    value: function heightL(_width, height) {
      return height <= ResponsiveTheme.L;
    }
  }, {
    key: "heightXL",
    value: function heightXL(_width, height) {
      return height <= ResponsiveTheme.XL;
    }
  }, {
    key: "heightXXL",
    value: function heightXXL(_width, height) {
      return height <= ResponsiveTheme.XXL;
    }
  }, {
    key: "isXXS",
    value: function isXXS(width, height) {
      return width <= ResponsiveTheme.XXS && height <= ResponsiveTheme.XXS;
    }
  }, {
    key: "isXS",
    value: function isXS(width, height) {
      return width <= ResponsiveTheme.XS && height <= ResponsiveTheme.XS;
    }
  }, {
    key: "isS",
    value: function isS(width, height) {
      return width <= ResponsiveTheme.S && height <= ResponsiveTheme.S;
    }
  }, {
    key: "isM",
    value: function isM(width, height) {
      return width <= ResponsiveTheme.M && height <= ResponsiveTheme.M;
    }
  }, {
    key: "isL",
    value: function isL(width, height) {
      return width <= ResponsiveTheme.L && height <= ResponsiveTheme.L;
    }
  }, {
    key: "isXL",
    value: function isXL(width, height) {
      return width <= ResponsiveTheme.XL && height <= ResponsiveTheme.XL;
    }
  }, {
    key: "isXXL",
    value: function isXXL(width, height) {
      return width <= ResponsiveTheme.XXL && height <= ResponsiveTheme.XXL;
    }
  }, {
    key: "maybeXXS",
    value: function maybeXXS(width, height) {
      return width <= ResponsiveTheme.XXS || height <= ResponsiveTheme.XXS;
    }
  }, {
    key: "maybeXS",
    value: function maybeXS(width, height) {
      return width <= ResponsiveTheme.XS || height <= ResponsiveTheme.XS;
    }
  }, {
    key: "maybeS",
    value: function maybeS(width, height) {
      return width <= ResponsiveTheme.S || height <= ResponsiveTheme.S;
    }
  }, {
    key: "maybeM",
    value: function maybeM(width, height) {
      return width <= ResponsiveTheme.M || height <= ResponsiveTheme.M;
    }
  }, {
    key: "maybeL",
    value: function maybeL(width, height) {
      return width <= ResponsiveTheme.L || height <= ResponsiveTheme.L;
    }
  }, {
    key: "maybeXL",
    value: function maybeXL(width, height) {
      return width <= ResponsiveTheme.XL || height <= ResponsiveTheme.XL;
    }
  }, {
    key: "maybeXXL",
    value: function maybeXXL(width, height) {
      return width <= ResponsiveTheme.XXL || height <= ResponsiveTheme.XXL;
    }
    /**
     * Instantiates the theme without adding default respomsive rules.
     */
  }, {
    key: "newEmpty",
    value: function newEmpty(root) {
      return new this(root, true);
    }
  }]);
  return ResponsiveTheme;
}(Theme);
// Named pixel breakpoints
Object.defineProperty(ResponsiveTheme, "XXS", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 100
});
Object.defineProperty(ResponsiveTheme, "XS", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 200
});
Object.defineProperty(ResponsiveTheme, "S", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 300
});
Object.defineProperty(ResponsiveTheme, "M", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 400
});
Object.defineProperty(ResponsiveTheme, "L", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 600
});
Object.defineProperty(ResponsiveTheme, "XL", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 800
});
Object.defineProperty(ResponsiveTheme, "XXL", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 1000
});